/*
 * @Author: chenjx
 * @Date: 2023-02-25 14:48:10
 * @LastEditors: chenjx
 * @LastEditTime: 2023-03-02 18:24:46
 * @Description: file content
 * @FilePath: \hyt\src\apis\index.js
 */
const api = {
  baseInfo: '/api/hyt/index/baseinfo',
  about: '/api/hyt/index/about',
  sendcode: '/api/hyt/index/sendcode',
  product: '/api/hyt/index/product',
  newslist: '/api/hyt/index/newslist',
  doclist: '/api/hyt/index/doclist',
  words: '/api/hyt/index/words',
  newsdetail: '/api/hyt/index/newsdetail',
  docdetail: '/api/hyt/index/docdetail',
  index: '/api/hyt/index/index'
}

const apis = {}
Object.keys(api).forEach(key => {
  apis[key] = `/apis${api[key]}`
})

export default apis